import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, computed } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { useStore } from "vuex";
  import plural from "@/features/plural";
  import { debounce } from "@/helpers/debounce";
  import { useToast } from "vue-toastification";
  import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { SalesPersonInterface } from "@/types/SalesPersonInterface";

  const tooltipText = "The invitation was already sent";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SalesPersonList',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const toast = useToast();
  const activeFilter = ref({
    title: "Any",
    _id: "",
  });
  const searchQuery = ref("");
  const showConfirmDeleteModal = ref(false);
  const loading = ref(false);
  const estates = ref<EstateInterface[] | null>([]);
  const salesPersonForDelete = ref<SalesPersonInterface | null>();
  const salesPersonFullNameForDelete = computed(() => {
    return salesPersonForDelete.value
      ? `${salesPersonForDelete.value?.firstName} ${salesPersonForDelete.value?.lastName}`
      : "";
  });

  const titles = ["Name", "Email", "Phone Number", "Project(s)", "Status"];

  const users = ref<SalesPersonInterface[]>([]);

  onMounted(() => {
    getEstates();
    getUsersSalesPerson();
  });

  const getEstates = () => {
    store
      .dispatch("estate/getEstates", {
        landownerId: store.state.user.data._id,
      })
      .then((res) => {
        estates.value = res.data;
      });
  };

  const getUsersSalesPerson = () => {
    loading.value = true;
    store
      .dispatch("user/getUsersSalesPerson", {
        search: searchQuery.value,
        estateIds:
          activeFilter.value.title === "Any" ? null : activeFilter.value._id,
      })
      .then((res) => {
        users.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  };
  const debounceSearch = debounce(getUsersSalesPerson);

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  const sendInvite = (id: string, email: string) => {
    loading.value = true;
    store
      .dispatch("user/resendActivationEmail", {
        email,
        userId: id,
      })
      .then(() => {
        toast.success("Email was successfully sent");
        getUsersSalesPerson();
      });
  };

  const changeFilter = (item: EstateInterface) => {
    activeFilter.value = item;
    getUsersSalesPerson();
  };

  const deleteSalesPerson = () => {
    if (salesPersonForDelete.value) {
      store
        .dispatch("user/deleteSalesPerson", salesPersonForDelete.value._id)
        .then((res) => {
          getUsersSalesPerson();
          toast.success(res.data.message);
        });
    }
  };

const __returned__ = { store, toast, activeFilter, searchQuery, showConfirmDeleteModal, loading, estates, salesPersonForDelete, tooltipText, salesPersonFullNameForDelete, titles, users, getEstates, getUsersSalesPerson, debounceSearch, sendInvite, changeFilter, deleteSalesPerson, ref, onMounted, watch, computed, DropDown, InputSearch, get useStore() { return useStore }, get plural() { return plural }, get debounce() { return debounce }, get useToast() { return useToast }, ConfirmDeleteModal, get EstateInterface() { return EstateInterface }, get SalesPersonInterface() { return SalesPersonInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})